export default "__VITE_ASSET__WtToeYK$__"